(function () {
  'use strict';

  if (document.getElementById('LagSiteTooltip')) return;

  var tooltip = document.createElement('div');
  tooltip.id = 'LagSiteTooltip';
  tooltip.className = 'lag-site-tooltip';
  tooltip.setAttribute('role', 'tooltip');
  tooltip.hidden = true;
  document.body.appendChild(tooltip);

  var controlSelector = 'button, [role="button"], input[type="button"], input[type="submit"], input[type="reset"], a[href], summary, label[for]';
  var visualSelector = 'img, svg, [role="img"], .icon, [class^="icon-"], [class*=" icon-"]';
  var current = null;
  var hovered = null;
  var focused = null;
  var dismissed = null;
  var pointerPosition = null;
  var pointerInput = false;
  var showTimer;
  var fadeTimer;
  var touchInput = false;
  var titles = [];

  function clean(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function tooltipText(value) {
    return clean(value.replace(/\bL\.?\s*A\.?\s*GIRL\b/gi, 'L.A. GIRL').replace(/[-\u2010-\u2015\u2212]+/g, ' '));
  }

  function savedTitle(element) {
    var record = titles.find(function (entry) { return entry.element === element; });
    return clean(element.getAttribute('title') || (record && record.value));
  }

  function nameFor(element, withoutTitle) {
    var labelledBy = clean(element.getAttribute('aria-labelledby'));
    if (labelledBy) {
      var label = clean(labelledBy.split(' ').map(function (id) {
        var node = document.getElementById(id);
        return node ? node.textContent : '';
      }).join(' '));
      if (label) return label;
    }
    var name = clean(element.getAttribute('aria-label'));
    if (name) return name;
    if (element.matches('img')) return clean(element.getAttribute('alt')) || (withoutTitle ? '' : savedTitle(element));
    if (element.matches('input')) return clean(element.value) || (withoutTitle ? '' : savedTitle(element));
    var text = clean(element.innerText || element.textContent);
    if (text) return text;
    var image = element.querySelector('img[alt]');
    return (image && clean(image.getAttribute('alt'))) || (withoutTitle ? '' : savedTitle(element));
  }

  function describe(node, fromFocus) {
    if (!(node instanceof Element) || tooltip.contains(node) || node.closest('[data-site-tooltip="off"]')) return null;
    var visual = node.closest(visualSelector);
    var control = node.closest(controlSelector);
    // Text links need no extra layer. Image/icon links and button-styled links do.
    if (control && control.matches('a') && !visual && !control.querySelector(visualSelector) && !control.matches('.btn, .button, [role="button"]')) control = null;
    var target = control || visual;
    if (!target || target.closest('[hidden], [inert]')) return null;
    var image = node.closest('img');
    if (!image && fromFocus && control && control.matches('a')) image = control.querySelector('img');
    var text = clean(target.getAttribute('data-site-tooltip-text'));
    if (image && !text) {
      var display = image.closest('[data-tooltip-display-title]');
      if (display) {
        var title = clean(display.getAttribute('data-tooltip-display-title'));
        var sku = clean(display.getAttribute('data-tooltip-display-sku'));
        text = title + (title && sku ? ', SKU number is ' + sku : '');
      }
      if (!text) text = clean(image.getAttribute('alt'));
    }
    if (!text) text = nameFor(target);
    text = tooltipText(text);
    if (!text) return null; // Decorative, unnamed artwork has nothing useful to repeat.
    return { target: target, source: image || visual || node, text: text };
  }

  function removeDescription() {
    if (!current) return;
    var ids = clean(current.target.getAttribute('aria-describedby')).split(' ').filter(function (id) {
      return id && id !== tooltip.id;
    });
    if (ids.length) current.target.setAttribute('aria-describedby', ids.join(' '));
    else current.target.removeAttribute('aria-describedby');
  }

  function restoreTitles() {
    titles.forEach(function (entry) {
      if (!entry.element.hasAttribute('title')) entry.element.setAttribute('title', entry.value);
      if (entry.addedLabel && entry.element.getAttribute('aria-label') === entry.value) {
        if (entry.previousLabel === null) entry.element.removeAttribute('aria-label');
        else entry.element.setAttribute('aria-label', entry.previousLabel);
      }
    });
    titles = [];
  }

  function hide() {
    clearTimeout(showTimer);
    removeDescription();
    if (tooltip.hidden || tooltip.getAttribute('aria-hidden') === 'true') return;
    tooltip.classList.remove('is-visible');
    tooltip.setAttribute('aria-hidden', 'true');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      tooltip.hidden = true;
    } else {
      fadeTimer = setTimeout(function () { tooltip.hidden = true; }, 160);
    }
  }

  function release() {
    hide();
    restoreTitles();
    current = null;
    dismissed = null;
  }

  function position() {
    if (!current || tooltip.hidden || tooltip.getAttribute('aria-hidden') === 'true') return;
    var rect = current.target.getBoundingClientRect();
    if (!current.target.isConnected || !current.target.getClientRects().length || rect.bottom < 0 || rect.top > window.innerHeight) {
      release();
      return;
    }
    var width = tooltip.offsetWidth;
    var height = tooltip.offsetHeight;
    var left = Math.max(8, Math.min(rect.left + rect.width / 2 - width / 2, window.innerWidth - width - 8));
    var top = rect.bottom + 8;
    if (top + height > window.innerHeight - 8) top = rect.top - height - 8;
    top = Math.max(8, Math.min(top, window.innerHeight - height - 8));
    tooltip.style.left = left + 'px';
    tooltip.style.top = top + 'px';
  }

  function show() {
    if (!current || dismissed === current.target || !current.target.isConnected) return;
    // Keep the description inside the active modal's accessible/top-layer subtree.
    var host = current.target.closest('dialog[open], [role="dialog"][aria-modal="true"]') || document.body;
    if (tooltip.parentElement !== host) host.appendChild(tooltip);
    tooltip.textContent = current.text;
    // The name already communicates identical text; avoid announcing it twice.
    var accessibleText = tooltipText(nameFor(current.target));
    if (accessibleText !== current.text && accessibleText.replace(/\s*\(opens in new window\)$/i, '') !== current.text) {
      var ids = clean(current.target.getAttribute('aria-describedby')).split(' ').filter(Boolean);
      if (ids.indexOf(tooltip.id) === -1) ids.push(tooltip.id);
      current.target.setAttribute('aria-describedby', ids.join(' '));
    }
    clearTimeout(fadeTimer);
    var wasHidden = tooltip.hidden;
    tooltip.hidden = false;
    tooltip.removeAttribute('aria-hidden');
    position();
    if (tooltip.hidden || !current) return;
    if (wasHidden) void tooltip.offsetWidth; // Establish opacity zero before fading in.
    tooltip.classList.add('is-visible');
  }

  function request(description, delay) {
    clearTimeout(showTimer);
    if (!description) return;
    if (delay) hide();
    if (current && current.target === description.target) {
      current.text = description.text;
      showTimer = setTimeout(show, delay);
      return;
    }
    release();
    current = { target: description.target, source: description.source, text: description.text };
    // Suppress only this trigger's native titles, then restore on departure.
    var element = description.source;
    while (element instanceof Element) {
      if (element.hasAttribute('title')) {
        var record = { element: element, value: element.getAttribute('title') };
        // Some existing icon buttons use title as their only accessible name.
        // Keep that name available while suppressing the native visual popup.
        if (!nameFor(element, true) && clean(record.value)) {
          record.previousLabel = element.getAttribute('aria-label');
          record.addedLabel = true;
          element.setAttribute('aria-label', record.value);
        }
        titles.push(record);
        element.removeAttribute('title');
      }
      if (element === description.target) break;
      element = element.parentElement;
    }
    showTimer = setTimeout(show, delay);
  }

  function depart() {
    hide();
    if (focused && !pointerInput) request(focused, 0);
    else release();
  }

  function hoverAt(event) {
    pointerInput = true;
    touchInput = false;
    pointerPosition = { x: event.clientX, y: event.clientY };
    hovered = describe(event.target, false);
    if (hovered) request(hovered, 2000);
    else depart();
  }

  document.addEventListener('pointerover', function (event) {
    if (event.pointerType === 'touch') return;
    hoverAt(event);
  });

  document.addEventListener('pointermove', function (event) {
    if (event.pointerType === 'touch') return;
    if (pointerPosition && pointerPosition.x === event.clientX && pointerPosition.y === event.clientY) return;
    hoverAt(event);
  });

  document.addEventListener('pointerout', function (event) {
    if (event.pointerType === 'touch') return;
    var next = describe(event.relatedTarget, false);
    if (hovered && next && hovered.target === next.target) return;
    pointerInput = true;
    hovered = next;
    if (hovered) request(hovered, 2000);
    else depart();
  });

  document.addEventListener('focusin', function (event) {
    focused = describe(event.target, true);
    if (touchInput || pointerInput) return;
    if (focused) request(focused, 0);
  });

  document.addEventListener('focusout', function (event) {
    focused = describe(event.relatedTarget, true);
    if (focused && !pointerInput && !touchInput) request(focused, 0);
    else depart();
  });

  document.addEventListener('keydown', function (event) {
    touchInput = false;
    pointerInput = false;
    if (event.key === 'Escape' && current) {
      dismissed = current.target;
      hide();
    }
  });

  document.addEventListener('pointerdown', function (event) {
    pointerInput = true;
    touchInput = event.pointerType === 'touch';
    if (current && !tooltip.contains(event.target)) {
      dismissed = current.target;
      hide();
    }
  });
  window.addEventListener('resize', position);
  document.addEventListener('scroll', position, true);
})();
